import type { AppState, MutationClass } from '../../../models'
import type { StorageService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

import { APP_CONSTS } from '../app.consts'

export class SetMenuCollapsedMutation implements MutationClass {
  static execute(this: void, state: AppState, menuCollapsed: boolean): void {
    const storageService: StorageService = CONTAINER.get<StorageService>(TYPES.StorageService)
    storageService.setItem(APP_CONSTS.storage.menuCollapsed, menuCollapsed.toString())
    state.menuCollapsed = menuCollapsed
  }
}
